import _ from 'lodash';
import { appFormUtil } from 'modules/common';
import { StyledTextField } from 'modules/components/layer01';
import React from 'react';



export type ProjectRoomNamesFIeldsProps<T extends object, K extends keyof T> = {
  form: appFormUtil.InferReturn<T>;
  fieldName: K;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = <T extends object, K extends keyof T = keyof T, U extends object = { K: T[keyof T] }>(props: ProjectRoomNamesFIeldsProps<T, K>) => {
  const { genFieldProps } = props.form;

  const formStateField = props.form.formState[props.fieldName];
  if (_.isObjectLike(formStateField) && !_.isArray(formStateField)) {

    const keys = _.keys(formStateField) as (keyof T[K])[];

    return keys.map((node, i) => {
      let value = 0;
      const field = formStateField[node];
      if (_.isObject(field) && 'count' in field) {

        if (typeof field['count'] === 'number') {
          value = isPropertyOfFormstate(field, 'count')
            ? field['count']
            : 0;
        }

      }
      if (node === 'roof' || node === 'exterior' || node === 'interior') {
        return <></>;
      }
      return (
        <StyledTextField.FC
          key={i}
          {...genFieldProps(props.fieldName)}
          type='number'
          label={
            __formatLabel(node)
          }
          value={value.toString()}
          onChange={(e) => {
            props.form.dispatch({
              type: 'UPDATE',
              payload: {
                property: props.fieldName,
                value: {
                  ...formStateField,
                  [node]: {
                    ...formStateField[node],
                    count: _.toNumber(`${e.target.value}`)
                  }
                }
              }
            });
          }}
        />
      );
    });
  }
};


function isPropertyOfFormstate<T extends object, K extends keyof T>(object: T, property: string | K): property is K {
  return object[property as keyof T] !== undefined;
}


function __formatLabel(node: string | number | symbol): string {
  return _.snakeCase(node.toString() ?? '')
    .replace(/_/gm, ' ')
    .split(' ')
    .map((r) => _.upperFirst(r))
    .join(' ');
}
